package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

/** A series listing (poster + metadata). Episodes are fetched on demand via [SeriesInfo]. */
@Serializable
data class SeriesItem(
    val id: String,
    val sourceId: String,
    val seriesId: Int,
    val name: String,
    val posterUrl: String? = null,
    val plot: String? = null,
    val cast: String? = null,
    val director: String? = null,
    val genre: String? = null,
    val releaseDate: String? = null,
    val rating: Double? = null,
    val group: String? = null
)

/** Full series detail: ordered seasons, each with their episodes. */
@Serializable
data class SeriesInfo(
    val series: SeriesItem,
    val seasons: List<Season>
)

@Serializable
data class Season(
    val seasonNumber: Int,
    val name: String? = null,
    val overview: String? = null,
    val coverUrl: String? = null,
    val episodes: List<Episode> = emptyList()
)

@Serializable
data class Episode(
    val id: String,
    val seriesId: Int,
    val seasonNumber: Int,
    val episodeNumber: Int,
    val title: String,
    val streamUrl: String,
    val plot: String? = null,
    val durationSec: Long? = null,
    val coverUrl: String? = null
)
